import { createStore, Store } from 'vuex';

import { saveUpcomingEvents, removeEvent } from '@/utils/events-db';

import auth from './auth';
import notifications from './notifications';
import theme from './theme';
import calendars from './calendars';
import events from './events';
import subscriptions from './subscriptions';

import { state, RootStateI } from './state';
import { mutations } from './mutations';
import { EventStateI } from './events/state';

// Mirror loaded events into IndexedDB so reminders survive reloads and are
// available to the service worker. Debounced because the events list can be
// updated many times in quick succession (WebSocket streaming).
function persistEventsPlugin(s: Store<RootStateI>): void {
  if (typeof window === 'undefined') return;
  let timer: ReturnType<typeof setTimeout> | null = null;

  s.subscribe((mutation) => {
    if (mutation.type === 'events/addEvent' || mutation.type === 'events/updateEvent') {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        // `events` is a dynamically-registered module, not on RootStateI.
        const eventsState = (s.state as RootStateI & { events: EventStateI }).events;
        saveUpcomingEvents(eventsState.events).then(() => {
          // Nudge the service worker to re-check now that the cache changed.
          navigator.serviceWorker?.controller?.postMessage({ type: 'CHECK_EVENTS' });
        }).catch(() => undefined);
      }, 800);
    } else if (mutation.type === 'events/deleteEvent') {
      removeEvent(mutation.payload).catch(() => undefined);
    }
  });
}

const store: Store<RootStateI> = createStore({
  state,
  getters: {
  },
  mutations,
  actions: {
  },
  modules: {
  },
  plugins: [persistEventsPlugin],
});

store.registerModule('auth', auth);
store.registerModule('notifications', notifications);
store.registerModule('theme', theme);
store.registerModule('calendars', calendars);
store.registerModule('events', events);
store.registerModule('subscriptions', subscriptions);

export default store;
